// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[8].use[1]!../../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[8].use[2]!../../../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[0].oneOf[8].use[3]!../../../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[8].use[4]!../../../../../node_modules/antd/dist/reset.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.UnitCardBasicInfo_App__gYMTS {
  width: 100%;
}

/* Global Toast / Message enhancements */
.UnitCardBasicInfo_ant-message__iyRxm {
  top: 72px !important;
  z-index: 99999 !important;
}
.UnitCardBasicInfo_ant-message__iyRxm .UnitCardBasicInfo_ant-message-notice-content__Gh-I4 {
  border-radius: 10px !important;
  padding: 10px 18px !important;
  box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.08) !important;
  font-size: 13.5px !important;
  font-weight: 500 !important;
}

.UnitCardBasicInfo_ant-notification__8Z4Qs {
  top: 72px !important;
  z-index: 99999 !important;
}

/* Standalone Toast Keyframes */
@keyframes UnitCardBasicInfo_toast-progress__KuLCH {
  from {
    width: 100%;
  }
  to {
    width: 0%;
  }
}
@keyframes UnitCardBasicInfo_toast-slide-in__6tG5D {
  from {
    opacity: 0;
    transform: translateY(-10px) scale(0.97);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.UnitCardBasicInfo_animate-toast-in__h8nvF {
  animation: UnitCardBasicInfo_toast-slide-in__6tG5D 0.22s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}

.UnitCardBasicInfo_basic-info__kdpG- {
  width: 100%;
}
.UnitCardBasicInfo_basic-info__kdpG- .UnitCardBasicInfo_tabs__5U5mB {
  min-height: 0;
  border-bottom: 1px solid var(--light-grey);
  overflow-x: auto;
}
.UnitCardBasicInfo_basic-info__kdpG- .UnitCardBasicInfo_tabs--item__F2OTx {
  min-width: 0;
  min-height: 0;
  text-transform: initial;
  font-size: 13px;
}
.UnitCardBasicInfo_basic-info__kdpG- .UnitCardBasicInfo_tabs--item__F2OTx.UnitCardBasicInfo_selected__v46d5 {
  color: var(--secondary-color);
}
.UnitCardBasicInfo_basic-info__kdpG- .UnitCardBasicInfo_tabs--indicator__px5ze {
  background-color: var(--secondary-color);
}
.UnitCardBasicInfo_basic-info__kdpG- .UnitCardBasicInfo_tabs--content__BghN- {
  padding: 8px;
  max-height: 400px;
  overflow-y: auto;
}
.UnitCardBasicInfo_basic-info__kdpG- .UnitCardBasicInfo_scholars-list__ZckjO {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

@media only screen and (max-width: 480px) {
  .UnitCardBasicInfo_basic-info__kdpG- {
    display: grid;
    padding: 16px;
    background: #fff;
    border: 1px solid var(--light-grey);
    border-radius: 10px;
  }
  .UnitCardBasicInfo_basic-info__kdpG- .MuiTabs-root {
    position: relative;
  }
  .UnitCardBasicInfo_basic-info__kdpG- .MuiTabs-root .MuiTabScrollButton-root {
    position: absolute;
    top: 0;
    height: 100%;
    background-color: white;
    z-index: 1;
  }
  .UnitCardBasicInfo_basic-info__kdpG- .MuiTabs-root .MuiTabScrollButton-root:first-child {
    left: 0;
  }
  .UnitCardBasicInfo_basic-info__kdpG- .MuiTabs-root .MuiTabScrollButton-root:last-child {
    right: 0;
  }
  .UnitCardBasicInfo_basic-info__kdpG- {
    background: transparent;
    border: none;
    border-radius: 0;
  }
}`, "",{"version":3,"sources":["webpack://./src/App.scss","webpack://./src/Explore/Components/UnitCardList/BasicInfo/UnitCardBasicInfo.module.scss"],"names":[],"mappings":"AACA;EACE,WAAA;ACCF;;ADiFA,wCAAA;AACA;EACE,oBAAA;EACA,yBAAA;AC9EF;ADgFE;EACE,8BAAA;EACA,6BAAA;EACA,+FAAA;EACA,4BAAA;EACA,2BAAA;AC9EJ;;ADkFA;EACE,oBAAA;EACA,yBAAA;AC/EF;;ADkFA,+BAAA;AACA;EACE;IACE,WAAA;EC/EF;EDiFA;IACE,SAAA;EC/EF;AACF;ADkFA;EACE;IACE,UAAA;IACA,wCAAA;EChFF;EDkFA;IACE,UAAA;IACA,iCAAA;EChFF;AACF;ADmFA;EACE,+FAAA;ACjFF;;AA1CA;EACE,WAAA;AA6CF;AA5CE;EACE,aAAA;EACA,0CAAA;EACA,gBAAA;AA8CJ;AA5CI;EACE,YAAA;EACA,aAAA;EACA,uBAAA;EACA,eAAA;AA8CN;AA5CM;EACE,6BAAA;AA8CR;AA1CI;EACE,wCAAA;AA4CN;AAzCI;EACE,YAAA;EACA,iBAAA;EACA,gBAAA;AA2CN;AAvCE;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AAyCJ;;AArCA;EACE;IACE,aAAA;IDmBF,aAAA;IACA,gBAAA;IACA,mCAAA;IACA,mBAAA;ECsBA;EDrBA;IACE,kBAAA;ECuBF;EDrBE;IACE,kBAAA;IACA,MAAA;IACA,YAAA;IACA,uBAAA;IACA,UAAA;ECuBJ;EDrBI;IACE,OAAA;ECuBN;EDpBI;IACE,QAAA;ECsBN;EA7DA;IAGE,uBAAA;IACA,YAAA;IACA,gBAAA;EA6DF;AACF","sourcesContent":["@import \"antd/dist/reset.css\";\n.App {\n  width: 100%;\n}\n\n@mixin antd-tab-mobile-wrapper {\n  box-shadow: rgba(0, 0, 0, 0.25) 0px 0px 10px 0px;\n  border-radius: 10px;\n\n  :global(.ant-tabs-nav) {\n    border-radius: 10px 10px 0 0;\n    overflow: hidden;\n  }\n\n  :global(.ant-tabs-nav-operations) {\n    display: none !important;\n  }\n\n  :global(.ant-tabs-tab) {\n    z-index: 1;\n    padding: 12px 16px;\n    margin: 0 !important;\n  }\n\n  :global(.ant-tabs-tabpane) {\n    padding: 0 16px !important;\n  }\n  :global(.ant-tabs-nav-wrap) {\n    &::before {\n      box-shadow: none !important;\n      content: \"\\2039\" !important;\n      font-size: 20px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background: linear-gradient(\n        90deg,\n        rgb(255, 255, 255) 25%,\n        rgba(255, 255, 255, 0) 100%\n      );\n    }\n\n    &::after {\n      box-shadow: none !important;\n      content: \"\\203A\" !important;\n      font-size: 20px;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      background: linear-gradient(\n        -90deg,\n        rgb(255, 255, 255) 25%,\n        rgba(255, 255, 255, 0) 100%\n      );\n    }\n  }\n}\n\n@mixin mui-tab-mobile-wrapper {\n  padding: 16px;\n  background: #fff;\n  border: 1px solid var(--light-grey);\n  border-radius: 10px;\n  :global(.MuiTabs-root) {\n    position: relative;\n\n    :global(.MuiTabScrollButton-root) {\n      position: absolute;\n      top: 0;\n      height: 100%;\n      background-color: white;\n      z-index: 1;\n\n      &:first-child {\n        left: 0;\n      }\n\n      &:last-child {\n        right: 0;\n      }\n    }\n  }\n}\n\n/* Global Toast / Message enhancements */\n.ant-message {\n  top: 72px !important;\n  z-index: 99999 !important;\n\n  .ant-message-notice-content {\n    border-radius: 10px !important;\n    padding: 10px 18px !important;\n    box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.08) !important;\n    font-size: 13.5px !important;\n    font-weight: 500 !important;\n  }\n}\n\n.ant-notification {\n  top: 72px !important;\n  z-index: 99999 !important;\n}\n\n/* Standalone Toast Keyframes */\n@keyframes toast-progress {\n  from {\n    width: 100%;\n  }\n  to {\n    width: 0%;\n  }\n}\n\n@keyframes toast-slide-in {\n  from {\n    opacity: 0;\n    transform: translateY(-10px) scale(0.97);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n.animate-toast-in {\n  animation: toast-slide-in 0.22s cubic-bezier(0.16, 1, 0.3, 1) forwards;\n}\n","@import \"App.scss\";\n\n.basic-info {\n  width: 100%;\n  .tabs {\n    min-height: 0;\n    border-bottom: 1px solid var(--light-grey);\n    overflow-x: auto;\n\n    &--item {\n      min-width: 0;\n      min-height: 0;\n      text-transform: initial;\n      font-size: 13px;\n\n      &.selected {\n        color: var(--secondary-color);\n      }\n    }\n\n    &--indicator {\n      background-color: var(--secondary-color);\n    }\n\n    &--content {\n      padding: 8px;\n      max-height: 400px;\n      overflow-y: auto;\n    }\n  }\n\n  .scholars-list {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n  }\n}\n\n@media only screen and (max-width: 480px) {\n  .basic-info {\n    display: grid;\n    @include mui-tab-mobile-wrapper;\n    background: transparent;\n    border: none;\n    border-radius: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"App": `UnitCardBasicInfo_App__gYMTS`,
	"ant-message": `UnitCardBasicInfo_ant-message__iyRxm`,
	"ant-message-notice-content": `UnitCardBasicInfo_ant-message-notice-content__Gh-I4`,
	"ant-notification": `UnitCardBasicInfo_ant-notification__8Z4Qs`,
	"animate-toast-in": `UnitCardBasicInfo_animate-toast-in__h8nvF`,
	"toast-slide-in": `UnitCardBasicInfo_toast-slide-in__6tG5D`,
	"basic-info": `UnitCardBasicInfo_basic-info__kdpG-`,
	"tabs": `UnitCardBasicInfo_tabs__5U5mB`,
	"tabs--item": `UnitCardBasicInfo_tabs--item__F2OTx`,
	"selected": `UnitCardBasicInfo_selected__v46d5`,
	"tabs--indicator": `UnitCardBasicInfo_tabs--indicator__px5ze`,
	"tabs--content": `UnitCardBasicInfo_tabs--content__BghN-`,
	"scholars-list": `UnitCardBasicInfo_scholars-list__ZckjO`,
	"toast-progress": `UnitCardBasicInfo_toast-progress__KuLCH`
};
export default ___CSS_LOADER_EXPORT___;
